import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { AGENCIES_ROUTE_CONFIG } from '@/pages/Agencies/AgenciesPage.config';

// Was a hand-written validator carrying `page` only, because the search term lived in component
// state. Now the search is URL-driven too, so the schema comes from the same config the page
// renders from — a param the route does not declare is stripped on the next navigation.
export const Route = createFileRoute('/agencies/')({
  validateSearch: generateValidateSearch(AGENCIES_ROUTE_CONFIG),
});
